import React, { useState } from 'react';
import '../styles/ImageGenerator.css';
import { FaImage, FaSpinner } from 'react-icons/fa';

const API_KEY = 'sk-i85F1oJBci62jqKyQMoIf0Uk7FHZPKfd784GiMzwVBISoDX3';
const API_URL = 'https://api.stability.ai/v1/generation/stable-diffusion-xl-1024-v1-0/text-to-image';

const ImageGenerator = () => {
  const [prompt, setPrompt] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [generatedImage, setGeneratedImage] = useState(null);
  const [imageStatus, setImageStatus] = useState('idle');

  const generateImage = async () => {
    if (!prompt.trim()) {
      setError('Please enter a prompt');
      return;
    }

    setLoading(true);
    setError('');
    setImageStatus('generating');
    setGeneratedImage(null);

    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${API_KEY}`,
        },
        body: JSON.stringify({
          text_prompts: [
            {
              text: prompt,
              weight: 1
            }
          ],
          cfg_scale: 7,
          height: 1024,
          width: 1024,
          steps: 30,
          samples: 1
        })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to generate image');
      }

      const data = await response.json();
      console.log('API Response:', data);

      if (data.artifacts && data.artifacts.length > 0) {
        const imageUrl = `data:image/png;base64,${data.artifacts[0].base64}`;
        setGeneratedImage(imageUrl);
        setImageStatus('completed');
      } else {
        throw new Error('No image generated');
      }
    } catch (err) {
      console.error('API Error:', err);
      setError(err.message || 'Failed to generate image');
      setImageStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="image-generator">
      <div className="generator-header">
        <FaImage className="header-icon" />
        <h2>AI Image Generation</h2>
        <p>Create unique images using advanced AI models</p>
      </div>

      <div className="generator-content">
        <div className="input-section">
          <textarea
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder="Describe the image you want to generate..."
            className="prompt-input"
            disabled={loading}
          />
          <button 
            onClick={generateImage} 
            disabled={loading || !prompt.trim()}
            className="generate-button"
          >
            {loading ? (
              <>
                <FaSpinner className="spinner" />
                Generating...
              </>
            ) : 'Generate Image'}
          </button>
        </div>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <div className="result-section">
          {imageStatus === 'generating' && (
            <div className="loading-state">
              <FaSpinner className="spinner" />
              <p>Creating your masterpiece...</p>
            </div>
          )}
          
          {generatedImage && (
            <div className="image-result">
              <img src={generatedImage} alt="AI Generated" />
              <a 
                href={generatedImage}
                download="ai-generated-image.png"
                className="download-button"
              >
                Download Image
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageGenerator; 